import React, { useEffect } from "react";
import {
  GetComplaintsForOrganizations,
  GetComplaintDetails,
  GetNilonLevelsDropDownList,
} from "api/apiService";
import Const from "const.json";
import ComplaintList from "components/controls/ComplaintList/ComplaintList";
import { useYearFromRedux } from "utils/utilsLogic";

const ComplaintOnOrganizationsList: React.FC = () => {
  
  const { comparisonTextToLastYear } = useYearFromRedux();

  return (
    <div>
      <ComplaintList
        fetchData={GetComplaintsForOrganizations}
        fetchDetails={GetComplaintDetails}
        headerText={Const.CompaniesThatComplainedAbout}
        subheaderText={`${Const.nilunLevelLeadingComplaintsNumber}\n${comparisonTextToLastYear}`}
        isShowDetails={true}
        options={GetNilonLevelsDropDownList}
        title={Const.selectNilonLevel}
        placeholder={Const.typeNameOfNilonLevel}
        onSelect={GetComplaintsForOrganizations}
        isShowTextInIcon={false}
        isComparedOnYear={true}
      />
    </div>
  );
};

export default ComplaintOnOrganizationsList;
